import { render, staticRenderFns } from "./JsonItem.vue?vue&type=template&id=c3709ee8"
import script from "./JsonItem.vue?vue&type=script&lang=js"
export * from "./JsonItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports